export default __webpack_public_path__ + "static/media/DIBS-Letters-new.6e2fe480.svg";